import { TicketCategoryEnum, TicketSeverityEnum, TicketStatusEnum } from "../types";

export class Ticket {
  get severity(): TicketSeverityEnum {
    return this.urgency;
  }

  get createdAtFriendly(): string {
    return this.createdAt.toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  get number(): string {
    return this.id.replace(/-/g, '').slice(0, 8).toUpperCase();
  }

  private attachmentsSignedUrls: string[] = [];

  constructor(
    public id: string,
    public category: TicketCategoryEnum | null,
    public subject: string,
    public description: string,
    public createdAt: Date,
    public status: TicketStatusEnum,
    public userId: string,
    public userName: string,
    public email: string,
    public clientId: string,
    public clientBusinessName: string,
    public urgency: TicketSeverityEnum,
    public operatorId?: string,
    public operatorName?: string,
    public internalNote?: string,
    public attachments?: File[],
    public closedAt?: Date,
  ) {
  }

  addNote(note: string, operatorName: string) {
    const noteDate = new Date().toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });

    this.internalNote = `
Operator: ${operatorName}
Date: ${noteDate}
Note: ${note}
Ticket Status: ${this.status}
-------------------------------------------

${this.internalNote}
`;
  }

  isPending(): boolean {
    return !this.isClosed();
  }

  isClosed(): boolean {
    return this.status.toLowerCase() === TicketStatusEnum.RESOLVED.toLowerCase() || this.status.toLowerCase() === TicketStatusEnum.CLOSED.toLowerCase();
  }

  setAttachmentsSignedUrls(urls: string[]) {
    this.attachmentsSignedUrls = urls;
  }

  getAttachmentSignedUrls() {
    return this.attachmentsSignedUrls || [];
  }
}
